import { MINERVA_API_URL } from '@/config';
import { http } from '@/plugins/http';
import types from './mutation-types';

export function fetchPublisherSeries({ dispatch }, params) {
  return http.get(`${MINERVA_API_URL}/publishers/${params.publisher_id}/series`, { params })
    .then(res => (res.data))
    .then(series => (
      dispatch('setSeries', series)
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching publisher series:', err);
      return Promise.reject(err);
    });
}

export function fetchSeriesById({ dispatch }, seriesId) {
  return http.get(`${MINERVA_API_URL}/series/${seriesId}`)
    .then(res => (res.data))
    .then(series => (
      dispatch('setSeries', [series])
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching series by ID:', err);
      return Promise.reject(err);
    });
}

export function createNewSeries({ dispatch }, params) {
  return http.post(`${MINERVA_API_URL}/publishers/${params.publisher_id}/series`, params)
    .then(res => (res.data))
    .then(series => (
      dispatch('setSeries', [series])
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while creating a new series:', err);
      return Promise.reject(err);
    });
}

export function updateSeries({ dispatch }, params) {
  return http.patch(`${MINERVA_API_URL}/series/${params.id}`, params)
    .then(res => (res.data))
    .then(series => (
      dispatch('setSeries', [series])
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while updating a series:', err);
      return Promise.reject(err);
    });
}

export function uploadNewSeriesCoverImage({ dispatch }, { seriesId, imageFile }) {
  const formData = new FormData();
  formData.append('file', imageFile);

  return http.patch(`${MINERVA_API_URL}/series/${seriesId}/cover_images`, formData)
    .then(res => (res.data))
    .then(series => (
      dispatch('setSeries', [series])
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while uploading new series cover image:', err);
      return Promise.reject(err);
    });
}

export function addCardToSeries({ dispatch }, params) {
  return http.post(`${MINERVA_API_URL}/series/${params.series_id}/cards`, params)
    .then(res => (res.data))
    .then(card => (
      dispatch('setChapterCards', [card])
    ))
    .then(() => (
      dispatch('removeNonSeriesCardInStore', params.card_id)
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while adding card to a series:', err);
      return Promise.reject(err);
    });
}

export function removeSeries({ dispatch }, seriesId) {
  return http.delete(`${MINERVA_API_URL}/series/${seriesId}`)
    .then(() => (
      dispatch('removeSeriesInStore', seriesId)
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while removing a series:', err);
      return Promise.reject(err);
    });
}

export function updateSeriesCard({ dispatch }, params) {
  return http.patch(`${MINERVA_API_URL}/series/${params.series_id}/cards/${params.card_id}`, params)
    .then(res => (res.data))
    .then(card => (
      dispatch('setChapterCards', [card])
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while updating a series card:', err);
      return Promise.reject(err);
    });
}

export function removeCardFromSeries({ dispatch }, params) {
  return http.delete(`${MINERVA_API_URL}/series/${params.series_id}/cards/${params.card_id}`)
    .then(res => (res.data))
    .then(card => (
      dispatch('setNonSeriesCards', [card])
    ))
    .then(() => (
      dispatch('removeChapterCardInStore', params.card_id)
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while removing a card from series:', err);
      return Promise.reject(err);
    });
}

export function removePublisherCard({ dispatch }, cardId) {
  return http.delete(`${MINERVA_API_URL}/cards/${cardId}`)
    .then(() => (
      dispatch('removeChapterCardInStore', cardId)
    ))
    .then(() => (
      dispatch('removeNonSeriesCardInStore', cardId)
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while removing publisher card:', err);
      return Promise.reject(err);
    });
}

export function fetchNonSeriesCards({ dispatch }, params) {
  return http.get(`${MINERVA_API_URL}/publishers/${params.publisher_id}/non_series_cards`, { params })
    .then(res => (res.data))
    // TODO should save in store?
    .then(nonSeriesCards => (
      dispatch('setNonSeriesCards', nonSeriesCards)
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching non series cards:', err);
      return Promise.reject(err);
    });
}

export function fetchSeriesChapters({ dispatch }, seriesId) {
  return http.get(`${MINERVA_API_URL}/series/${seriesId}/chapters`)
    .then(res => (res.data))
    .then(chapters => (
      dispatch('setChapters', chapters)
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching series chapters:', err);
      return Promise.reject(err);
    });
}

export function updateChapter({ dispatch }, params) {
  return http.patch(`${MINERVA_API_URL}/chapters/${params.id}`, params)
    .then(res => (res.data))
    .then(chapter => (
      dispatch('setChapters', [chapter])
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while updating a chapter:', err);
      return Promise.reject(err);
    });
}

export function fetchChapterCards({ dispatch }, chapterId) {
  return http.get(`${MINERVA_API_URL}/chapters/${chapterId}/cards`)
    .then(res => (res.data))
    .then(cards => (
      dispatch('setChapterCards', cards)
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching chapter cards:', err);
      return Promise.reject(err);
    });
}

export function createVideoCourseCards({ commit }, data) {
  return http.post(`${MINERVA_API_URL}/video_courses_cards`, data)
    .then(res => commit(types.SET_VIDEO_COURSE_CARD, res.data))
    .catch(err => Promise.reject(err));
}

export function fetchVideoCourseCards({ commit }, params) {
  return http.get(`${MINERVA_API_URL}/video_courses_cards`, { params })
    .then(res => commit(types.FETCH_VIDEO_COURSE_CARDS, res.data))
    .catch(err => Promise.reject(err));
}

export function updateVideoCourseCards({ commit }, data) {
  return http.put(`${MINERVA_API_URL}/video_courses_cards/${data.id}`, data)
    .then(res => commit(types.UPDATE_VIDEO_COURSE_CARD, res.data))
    .catch(err => Promise.reject(err));
}

export function setSeries({ commit }, series) {
  commit(types.SET_SERIES, series);

  return Promise.resolve(series);
}

export function removeSeriesInStore({ commit }, seriesId) {
  commit(types.REMOVE_SERIES, seriesId);

  return Promise.resolve(seriesId);
}

export function setNonSeriesCards({ commit }, nonSeriesCards) {
  commit(types.SET_NON_SERIES_CARDS, nonSeriesCards);

  return Promise.resolve(nonSeriesCards);
}

export function removeNonSeriesCardInStore({ commit }, cardId) {
  commit(types.REMOVE_NON_SERIES_CARD, cardId);

  return Promise.resolve(cardId);
}

export function setChapters({ commit }, chapters) {
  commit(types.SET_CHAPTERS, chapters);

  return Promise.resolve(chapters);
}

export function setChapterCards({ commit }, cards) {
  commit(types.SET_CHAPTER_CARDS, cards);

  return Promise.resolve(cards);
}

export function removeChapterCardInStore({ commit }, cardId) {
  commit(types.REMOVE_CHAPTER_CARD, cardId);

  return Promise.resolve(cardId);
}

export function requestVideoCourseCard({ commit }) {
  return commit(types.REQUEST_VIDEO_COURSE_CARD, true);
}

export function updateExtraContent({ commit }, { pageId, params }) {
  const formData = new FormData();
  if (params.title) {
    formData.append('title', params.title);
  }
  if (params.imageFile) {
    formData.append('file', params.imageFile);
  }
  return http.post(`${MINERVA_API_URL}/pages/${pageId}/extra_contents`, formData);
}

export function removeExtraContent({ commit }, extraContentId) {
  return http.delete(`${MINERVA_API_URL}/extra_contents/${extraContentId}`);
}



// WEBPACK FOOTER //
// ./src/app/publishers/store/actions.js